var map = {
	"./images/2171317.png": 3643,
	"./images/2171335.png": 3702,
	"./images/2171339.png": 3652,
	"./images/2171431.png": 4709,
	"./images/Banner1.png": 2797,
	"./images/Banner2.png": 2417,
	"./images/Banner3.png": 5461,
	"./images/ButtonLeft.png": 236,
	"./images/ButtonRight.png": 1271,
	"./images/MyLocation.png": 1441,
	"./images/aButton.png": 6872,
	"./images/calc-icon.png": 7105,
	"./images/circle.png": 5934,
	"./images/doctor.png": 1374,
	"./images/drug-1.png": 4687,
	"./images/drug-10.png": 1097,
	"./images/drug-11.png": 4161,
	"./images/drug-12.png": 5015,
	"./images/drug-13.png": 225,
	"./images/drug-14.png": 2343,
	"./images/drug-15.png": 8255,
	"./images/drug-16.png": 2706,
	"./images/drug-17.png": 7203,
	"./images/drug-18.png": 4544,
	"./images/drug-19.png": 8861,
	"./images/drug-2.png": 178,
	"./images/drug-20.png": 7227,
	"./images/drug-3.png": 3451,
	"./images/drug-4.png": 3145,
	"./images/drug-5.png": 9978,
	"./images/drug-6.png": 6825,
	"./images/drug-7.png": 665,
	"./images/drug-8.png": 5245,
	"./images/drug-9.png": 6439,
	"./images/error.png": 8127,
	"./images/food-bean.png": 2603,
	"./images/food-broccoli.png": 4061,
	"./images/food-butter.png": 4828,
	"./images/food-chicken.png": 6188,
	"./images/food-chocolate.png": 5201,
	"./images/food-dailyproduct.png": 6320,
	"./images/food-egg.png": 8935,
	"./images/food-fish.png": 8307,
	"./images/food-fruits.png": 9166,
	"./images/food-kale.png": 6024,
	"./images/food-kiwi.png": 354,
	"./images/food-liver.png": 9496,
	"./images/food-meat.png": 7154,
	"./images/food-milk.png": 8064,
	"./images/food-nuts.png": 6913,
	"./images/food-oil.png": 2549,
	"./images/food-orange.png": 3785,
	"./images/food-potato.png": 6302,
	"./images/food-seafood.png": 8820,
	"./images/food-seaweed.png": 4785,
	"./images/food-spinach.png": 2126,
	"./images/food-sun.png": 4933,
	"./images/food-vegetable.png": 3950,
	"./images/footer.png": 7206,
	"./images/home-down.png": 9592,
	"./images/icon_down.png": 5425,
	"./images/icon_up.png": 2552,
	"./images/loadingpill.png": 6251,
	"./images/location-icon.png": 3729,
	"./images/location.png": 4752,
	"./images/medi.png": 1488,
	"./images/mediCharacter.png": 5381,
	"./images/mediLogo.png": 8421,
	"./images/no-show.png": 9077,
	"./images/nocheck_radio.png": 4653,
	"./images/searchkey.png": 1704,
	"./images/show.png": 6266,
	"./images/team.png": 2029,
	"./images/user.png": 4353,
	"./images/yescheck_radio.png": 985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;